export default "__VITE_ASSET__BJKN2Pom__"